<template>
  <div>
    <div>
      <div class="query_head">
        <span class="query_pond">{{$route.params.pond_name}}</span>
        <i class="el-icon-arrow-right"></i>
        <span class="query_sensor">数据查看</span>
      </div>
      <div class="query_chart">
        <el-tabs v-model="activeName"  @tab-click="handleClick">
          <el-tab-pane
            v-for="cell_Sensor in listSensor"
            :key="cell_Sensor.id"
            :label="cell_Sensor.name"
            :name="cell_Sensor.id">
            <div>
              <div class="cell_height">{{sensorName}}传感器当前采集数据</div>
              <div
                v-for="params in cell_params"
                :key="params.snpid"
                class="params_margin"
                v-if="params.name === cell_Sensor.name">
                <div class="params_flex">
                  {{params.typeCHN}}:
                  <div
                    v-for="(real,index) in real_data"
                    :key="index"
                    class="params_value"
                    v-if="real.snpid === params.snpid">
                    {{real.value}}
                  </div>
                  <span style="margin-left: 5px;">{{params.suffix}}</span>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div>
          <div class="his_flex">
            <div  class="cell_height">{{sensorName}}传感器历史采集数据</div>
            <div>
              <div>
                时间选择：
                <el-date-picker
                  v-model="his_time"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  align="right"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['12:00:00', '08:00:00']">
                </el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="hisQurey" ref="hisQurey" :style="{width: curWidth, height:'470px'}"></div>
      </div>
    </div>
    <div class="equip_margin">
      <div class="query_head">
        <span class="query_pond">{{$route.params.pond_name}}</span>
        <i class="el-icon-arrow-right"></i>
        <span class="query_sensor">设备控制</span>
      </div>
      <div class="query_chart query_table">
        <el-tabs v-model="activeName1">
          <el-tab-pane label="设备控制" name="first">
            <div class="margin_top_table">
              <el-table
                :data="listEquip"
                border
                >
                <el-table-column prop="num" label="序号"></el-table-column>
                <el-table-column prop="name" label="设备名称"></el-table-column>
                <el-table-column prop="type" label="设备类型"></el-table-column>
                <el-table-column fixed="right" label="设备启停">
                  <template slot-scope="scope">
                    <span>开</span>
                    <el-switch
                      v-model="scope.row.status"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      @change="changeStatus(scope.$index,scope.row)">
                    </el-switch>
                    <span>关</span>
                  </template>
                </el-table-column>
                <el-table-column prop="time" label="最近一次操作时间"></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="控制历史" name="second">
            <div class="control_his">
              <div>
                <el-form ref="form" :model="form" label-width="80px">
                  <el-form-item label="设备选择">
                    <el-select v-model="form.equip"  placeholder="请选择设备">
                      <el-option v-for="(equip,index) in  listEquip_id" :key="index" :label="equip.defname" :value="equip.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
              <div>
                <span class="margin_equip">时间选择</span>
                <el-date-picker
                  class="el-select"
                  v-model="his_time1"
                  type="datetimerange"
                  :picker-options="pickerOptions1"
                  align="right"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['12:00:00', '08:00:00']">
                </el-date-picker>
              </div>
            </div>
            <div class="margin_top_table">
              <el-table
                :data="listEquip_time"
                :span-method="objectSpanMethod"
                border>
                <el-table-column prop="num" label="序号"></el-table-column>
                <el-table-column prop="optlist" label="操作"></el-table-column>
                <el-table-column prop="timelist" label="操作时间"></el-table-column>
                <el-table-column prop="ondurt" label="累计开启时间"></el-table-column>
                <el-table-column prop="offdurt" label="累计关闭时间"></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      cell_id: this.$route.params.pond_id,
      listSensor: [],
      real_data: [],
      his_data: [],
      his_data_x: [],
      his_data_name: [],
      activeName: '',
      his_time: [],
      his_time1: [],
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username'),
      cell_params: [],
      sensor_params: [],
      listEquip: [],
      listEquip_id: [],
      listEquip_time: [],
      sensorName: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近半年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      pickerOptions1: {
        shortcuts: [{
          text: '最近一天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近半年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      flag1: '',
      activeName1: 'first',
      form: {
        equip: ''
      },
      length: '',
      curWidth: ''
    }
  },
  methods: {
    // 获取 传感器
    cellSensor () {
      this.axios.get(this.$store.state.ip + 'sensordef/cellSensors',
        {
          params: {'cell_id': this.cell_id},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res1 => {
        this.listSensor = res1.data.data
        for (let i = 0; i < this.listSensor.length; i++) {
          this.listSensor[i].id = this.listSensor[i].id.toString()
        }
        this.flag1 = false
        this.activeName = this.listSensor[0].id
        this.sensorName = this.listSensor[0].name
      }).catch(err => {
        console.log(err)
      })
    },
    // 环境采集参数
    cellParams () {
      this.axios.get(this.$store.state.ip + 'sensordef/cellParams',
        {
          params: {'cell_id': this.cell_id},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.cell_params = res.data.data
        this.real_time()
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24)
        this.his_time = [this.changeTime(start), this.changeTime(end)]
      }).catch(err => {
        console.log(err)
      })
    },
    handleClick (tab, event) {
      this.sensorName = tab.label
    },
    // 历史数据
    drawLine () {
      this.his_data = []
      this.his_data_x = []
      this.his_data_name = []
      this.sensor_params = []
      for (let i = 0; i < this.cell_params.length; i++) {
        if (this.cell_params[i].name === this.sensorName) {
          this.sensor_params.push(this.cell_params[i])
        }
      }
      this.axios.get(this.$store.state.ip + 'opt/hisQuery',
        {
          params: {'cell_id': this.cell_id, 'start_time': this.his_time[0], 'end_time': this.his_time[1]},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        for (let i = 0; i < res.data.data.length; i++) {
          for (let j = 0; j < this.sensor_params.length; j++) {
            for (let k = 0; k < res.data.data[i].sntvs.length; k++) {
              if (res.data.data[i].sntvs[k].snpid === this.sensor_params[j].snpid) {
                this.his_data.push(res.data.data[i].sntvs[k])
                this.his_data_name.push(this.sensor_params[j].typeCHN)
              }
            }
          }
        }
        this.his_data_x = this.his_data[0].times
        for (let i = 0; i < this.his_data.length - 1; i++) {
          for (let j = i + 1; j < this.his_data.length; j++) {
            if (this.his_data[i].times.length < this.his_data[j].times.length) {
              this.his_data_x = this.his_data[j].times
            }
          }
        }
        for (let t = 0; t < this.his_data_x.length; t++) {
          this.his_data_x[t] = this.resetTime(this.his_data_x[t])
        }
        var series = []
        let flag = -1
        const color1 = ['#91c7ae', '#d48265', '#61a0a8', '#2f4554', '#749f83', '#c23531']
        for (let i = 0; i < this.his_data.length; i++) {
          flag = flag + 1
          if (flag === 6) { // 拆线图颜色初始化
            flag = 0
          }
          var test = []
          for (let j = 0; j < this.his_data[i].times.length; j++) {
            test = test.concat({
              'time': this.resetTime(this.his_data[i].times[j]),
              'value': this.his_data[i].values[j]
            })
          }
          series.push({
            name: this.his_data_name[i],
            type: 'line',
            itemStyle: {
              normal: {
                lineStyle: { // 折线样式
                  width: 2.5,
                  type: 'solid',
                  color: color1[i] // 折线颜色
                }
              },
              emphasis: {
                color: color1[i],
                lineStyle: {
                  type: 'dotted',
                  color: color1[i]
                }
              }
            },
            symbolSize: 5,
            data: test
          })
        }
        // 打印 历史数据
        let mycharts = this.$echarts.init(this.$refs.hisQurey)
        mycharts.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          color: ['#91c7ae', '#d48265', '#61a0a8', '#2f4554', '#749f83', '#c23531'],
          legend: {
            left: 20,
            data: this.his_data_name
          },
          dataZoom: [
            {
              show: true,
              realtime: true,
              start: 0
              // end: 25 / this.his_data_x[0].length * 100
            },
            {
              type: 'inside',
              realtime: true,
              start: 0,
              end: 100
            }
          ],
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.his_data_x
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: series
        }, true)
      }).catch(err => {
        console.log(err)
      })
    },
    // 实时数据
    real_time () {
      this.axios.get(this.$store.state.ip + 'opt/rtQuery',
        {
          params: {'cell_id': this.cell_id},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.real_data = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    // 时间戳转换为标准时间
    resetTime (time) {
      let test = new Date(time * 1000)
      let year = test.getFullYear() // 取得4位数的年份
      let month = ('0' + (test.getMonth() + 1)).slice(-2) // 取得日期中的月份，其中0表示1月，11表示12月
      let date = ('0' + test.getDate()).slice(-2) // 返回日期月份中的天数（1到31）
      let hour = ('0' + test.getHours()).slice(-2) // 返回日期中的小时数（0到23）
      let minute = ('0' + test.getMinutes()).slice(-2) // 返回日期中的分钟数（0到59）
      let second = ('0' + test.getSeconds()).slice(-2) // 返回日期中的秒数（0到59）
      return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
    },
    // 获取 生产单元下的设备
    getUserEquips () {
      this.axios.get(this.$store.state.ip + 'equipdef/listEquips',
        {
          params: {'cell_id': this.cell_id},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listEquip_id = res.data.data
      }).catch(err => {
        console.log(err)
      })
      this.axios.get(this.$store.state.ip + 'opt/equQuery',
        {
          params: {'cell_id': this.cell_id},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listEquip = res.data.data
        for (let i = 0; i < this.listEquip.length; i++) {
          for (let j = 0; j < this.listEquip_id.length; j++) {
            if (this.listEquip_id[j].defname === this.listEquip[i].name) {
              this.listEquip[i].id = this.listEquip_id[j].id
              break
            }
          }
          this.listEquip[i].num = i + 1
          if (this.listEquip[i].status === 0) {
            this.listEquip[i].status = false
          } else {
            this.listEquip[i].status = true
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 查看设备的更改日志
    getAllhis () {
      this.listEquip_time = []
      this.axios.get(this.$store.state.ip + 'opt/equLogQuery',
        {
          params: {'cell_id': this.cell_id, 'start_time': this.his_time1[0], 'end_time': this.his_time1[1]},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        for (let i = 0; i < res.data.data.length; i++) {
          if (this.form.equip === res.data.data[i].eqpid) {
            for (let j = 0; j < res.data.data[i].optlist.length; j++) {
              this.listEquip_time = this.listEquip_time.concat({'num': j + 1})
              this.listEquip_time[j].timelist = this.resetTime(res.data.data[i].timelist[j])
              if (res.data.data[i].optlist[j] === 0) {
                this.listEquip_time[j].optlist = '关闭'
              } else {
                this.listEquip_time[j].optlist = '开启'
              }
              this.listEquip_time[j].ondurt = this.changSecond(res.data.data[i].ondurt)
              this.listEquip_time[j].offdurt = this.changSecond(res.data.data[i].offdurt)
            }
            break
          }
        }
        this.length = this.listEquip_time.length
      }).catch(err => {
        console.log(err)
      })
    },
    // 把秒转换为天时分秒
    changSecond (second) {
      let theTime = parseInt(second) // 需要转换的时间秒
      let theTime1 = 0 // 分
      let theTime2 = 0 // 小时
      let theTime3 = 0 // 天
      if (theTime > 60) {
        theTime1 = parseInt(theTime / 60)
        theTime = parseInt(theTime % 60)
        if (theTime1 > 60) {
          theTime2 = parseInt(theTime1 / 60)
          theTime1 = parseInt(theTime1 % 60)
          if (theTime2 > 24) {
            // 大于24小时
            theTime3 = parseInt(theTime2 / 24)
            theTime2 = parseInt(theTime2 % 24)
          }
        }
      }
      let result = ''
      if (theTime > 0) {
        result = '' + parseInt(theTime) + '秒'
      }
      if (theTime1 > 0) {
        result = '' + parseInt(theTime1) + '分' + result
      }
      if (theTime2 > 0) {
        result = '' + parseInt(theTime2) + '小时' + result
      }
      if (theTime3 > 0) {
        result = '' + parseInt(theTime3) + '天' + result
      }
      return result
    },
    // 合并列
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3 || columnIndex === 4) {
        return {
          rowspan: this.length,
          colspan: 1
        }
      }
    },

    changeTime (time) {
      const resDate = time.getFullYear() + '-' + this.p((time.getMonth() + 1)) + '-' + this.p(time.getDate())
      const resTime = this.p(time.getHours()) + ':' + this.p(time.getMinutes()) + ':' + this.p(time.getSeconds())
      return resDate + ' ' + resTime
    },
    p (s) {
      return s < 10 ? '0' + s : s
    }
  },
  created () {
    this.cellSensor()
    this.cellParams()
    this.getUserEquips()
    this.curWidth = document.body.clientWidth - 260 + 'px'
  },
  watch: {
    $route (to, from) {
      this.$router.go(0)
    },
    'his_time': function () {
      this.drawLine()
      this.flag1 = true
    },
    'activeName': function () {
      if (this.flag1 === true) {
        this.drawLine()
      }
    },
    'activeName1': function () {
      if (this.activeName1 === 'first') {
        this.getUserEquips()
      }
    },
    'his_time1': function () {
      this.getAllhis()
    }
  }
}
</script>

<style scoped>
  .cell_height {
    display: block;
    text-align: left;
    margin-bottom: 20px;
    margin-top: 10px;
    color: #333;
    font-size: 18px;
    font-weight: bold;
    font-style: italic;
  }
  .params_margin {
    margin-right: 20px;
    margin-left: 20px;
    width: 100%;
  }
  .params_flex {
    display: flex;
    float: left;
    width: 33%;
    margin-bottom: 30px;
  }
  .params_value {
    margin-left: 10px;
    font-weight: bold;
  }
  .equip_margin {
    margin-top: 20px;
  }
  .margin_top_table {
    margin-top: 20px;
  }
  .his_flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 20px;
    margin-bottom: 30px;
  }
  .control_his {
    display: flex;
    width: 800px;
    text-align: left;
  }
  .el-select {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
  .margin_equip {
    margin-left: 20px;
    margin-right: 5px;
    font-size: 14px;
    color: #606266;
  }
</style>



// WEBPACK FOOTER //
// src/components/userData/Query.vue